import { Controller } from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = ["adsRow"]

  connect() {
    if (this._hasHideCookie()) {
      this.hideAds();
    }
  }

  hideAds(){
    const adsName = this.adsRowTarget.dataset.marketId;

    if (!this._hasHideCookie()) {
      this._setCookie(adsName);
    }

    this.adsRowTarget.classList.add("d-none");
  }

  _setCookie(adsName) {
    const HOURS_TO_EXPIRE = 8;

    Cookies.set(adsName, 'true', {
      expires: new Date(new Date().getTime() + HOURS_TO_EXPIRE * 3600 * 1000),
    });
  }

  _hasHideCookie() {
    const adsName = this.adsRowTarget.dataset.marketId;

    return Cookies.get(adsName) === "true";
  }
}
